/*
 * @Description:
 * @Author: seam
 * @Date: 2021-08-09 14:05:44
 * @LastEditors: seam
 * @LastEditTime: 2021-08-09 14:18:03
 * @FilePath: \mgmt-client\src\libs\filter.js
 */
import { types_name } from './category'
/**
 * 商标分类格式化
 * @param {*} value
 * @param {*} detail
 */
 export function typeFormat(value, detail = false) {
  if (!value) return ''
  const intcls = parseInt(value) < 10 ? `0${value}` : value
  if (detail) {
    if (value === 33) {
      return `第${intcls}类-${types_name[value - 1]['title']}`
    }
    return `第${intcls}类-${types_name[value - 1]['title']}`
  }
  return intcls
}



// WEBPACK FOOTER //
// ./src/libs/filter.js